/**
 * Router configuration
 */

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { LoadingOverlay } from '@/components/common';

// Lazy load pages
const MapPage = lazy(() => import('@/pages/MapPage').then(m => ({ default: m.MapPage })));
const AdminPage = lazy(() => import('@/pages/AdminPage').then(m => ({ default: m.AdminPage })));
const ResetPasswordPage = lazy(() => import('@/pages/ResetPasswordPage').then(m => ({ default: m.ResetPasswordPage })));
const VerifyEmailPage = lazy(() => import('@/pages/VerifyEmailPage').then(m => ({ default: m.VerifyEmailPage })));

// Lazy load admin components
const AdminLayout = lazy(() => import('@/components/admin').then(m => ({ default: m.AdminLayout })));
const UsersTable = lazy(() => import('@/components/admin').then(m => ({ default: m.UsersTable })));
const RolesView = lazy(() => import('@/components/admin').then(m => ({ default: m.RolesView })));
const UsageCharts = lazy(() => import('@/components/admin').then(m => ({ default: m.UsageCharts })));
const AuditLogTable = lazy(() => import('@/components/admin').then(m => ({ default: m.AuditLogTable })));

// Router configuration
const router = createBrowserRouter([
  // Map routes
  {
    path: '/',
    element: (
      <Suspense fallback={<LoadingOverlay />}>
        <MapPage />
      </Suspense>
    ),
  },
  {
    path: '/plot/:id',
    element: (
      <Suspense fallback={<LoadingOverlay />}>
        <MapPage />
      </Suspense>
    ),
  },
  {
    path: '/concession/:id',
    element: (
      <Suspense fallback={<LoadingOverlay />}>
        <MapPage />
      </Suspense>
    ),
  },
  {
    path: '/owner/:ruc',
    element: (
      <Suspense fallback={<LoadingOverlay />}>
        <MapPage />
      </Suspense>
    ),
  },
  {
    path: '/search',
    element: (
      <Suspense fallback={<LoadingOverlay />}>
        <MapPage />
      </Suspense>
    ),
  },
  {
    path: '/stats',
    element: (
      <Suspense fallback={<LoadingOverlay />}>
        <MapPage />
      </Suspense>
    ),
  },
  {
    path: '/favorites',
    element: (
      <Suspense fallback={<LoadingOverlay />}>
        <MapPage />
      </Suspense>
    ),
  },
  {
    path: '/export',
    element: (
      <Suspense fallback={<LoadingOverlay />}>
        <MapPage />
      </Suspense>
    ),
  },
  {
    path: '/reports',
    element: (
      <Suspense fallback={<LoadingOverlay />}>
        <MapPage />
      </Suspense>
    ),
  },

  // Auth routes
  {
    path: '/reset-password',
    element: (
      <Suspense fallback={<LoadingOverlay />}>
        <ResetPasswordPage />
      </Suspense>
    ),
  },
  {
    path: '/verify-email',
    element: (
      <Suspense fallback={<LoadingOverlay />}>
        <VerifyEmailPage />
      </Suspense>
    ),
  },

  // Admin routes
  {
    path: '/admin',
    element: (
      <Suspense fallback={<LoadingOverlay />}>
        <AdminLayout />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingOverlay />}>
            <AdminPage />
          </Suspense>
        ),
      },
      {
        path: 'users',
        element: (
          <Suspense fallback={<LoadingOverlay />}>
            <UsersTable />
          </Suspense>
        ),
      },
      {
        path: 'roles',
        element: (
          <Suspense fallback={<LoadingOverlay />}>
            <RolesView />
          </Suspense>
        ),
      },
      {
        path: 'usage',
        element: (
          <Suspense fallback={<LoadingOverlay />}>
            <UsageCharts />
          </Suspense>
        ),
      },
      {
        path: 'audit',
        element: (
          <Suspense fallback={<LoadingOverlay />}>
            <AuditLogTable />
          </Suspense>
        ),
      },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
